import { Box, CircularProgress, CircularProgressProps, LinearProgress, LinearProgressProps } from '@mui/material';

interface Linear extends Omit<LinearProgressProps, 'variant'> {
  variant?: 'line';
}

interface Circular extends Omit<CircularProgressProps, 'variant'> {
  variant?: 'circle';
}

type Props = Linear | Circular;

export const CenteredLoader = ({ variant = 'circle', ...rest }: Props) => (
  <Box
    sx={{
      alignItems: 'center',
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
    }}
  >
    {variant === 'circle' ? <CircularProgress {...rest} /> : <LinearProgress {...rest} />}
  </Box>
);
